import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import adapter from './adapter'
import service from './service'

const initialState = {
  _payload: null,
  status: 'idle',
  error: '',
  data: [],

  respond_status: 'idle',
  respond_error: '',
  respond_data: [],
}

export const fetchJoinRequests = createAsyncThunk('joinRequests/fetchJoinRequests', async (options) => {
  const data = await service.getData(options)
  return data
})

export const respond = createAsyncThunk('joinRequests/respond', async (options) => {
  const data = await service.respond(options)
  return data
})

export const joinRequestsSlice = createSlice({
  name: 'joinRequests',
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    }
  },
  extraReducers: {
    // Bulk
    [fetchJoinRequests.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchJoinRequests.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state._payload = action.payload
      state.data = action.payload
        .map(a => adapter.responseBodyToRender(a))
        // type 1 = invitation. type 2 = join request
        .filter(a => a.type === 2)
    },
    [fetchJoinRequests.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },

    [respond.pending]: (state) => {
      state.respond_status = 'loading'
    },
    [respond.fulfilled]: (state, action) => {
      state.respond_status = 'succeeded'
      state.respond_data = action.payload
    },
    [respond.rejected]: (state, action) => {
      state.respond_status = 'failed'
      state.respond_error = action.error.message
    },
  }
})

export const { setStatus } = joinRequestsSlice.actions

export default joinRequestsSlice.reducer
